<script setup>
import _ from "lodash";

import { useThreadsContextStore } from "@/stores/threads";
import { useNavigation } from "@/composables/useNavigation";
import { useCountsStore } from "@/stores/counts";
import api from "@/api";

const threadsStore = useThreadsContextStore();
const { queryParams, routeMeta } = useNavigation();
const countsStore = useCountsStore();
const currentCategory = computed(() => routeMeta.value.category);
provide("CURRENT_CATEGORY", currentCategory);

const getThreads = async (filters) => {
  // Include current inbox category so API can apply route-specific rules (e.g. mine + sidebar filters).
  const filtersWithCategory = {
    ...filters,
    _inbox_category: currentCategory.value,
  };

  // clean filters - if filters are empty arrays remove them
  Object.entries(filtersWithCategory).forEach(([key, value]) => {
    if (
      value === null ||
      value === undefined ||
      (Array.isArray(value) && value.length === 0)
    ) {
      delete filtersWithCategory[key];
    }
  });

  await threadsStore.fetchThreads(filtersWithCategory);
  // probably not needed since this is when filters update
  // but we want counts to stay accurate, so any status change/modification shud trigger it inside inbox.vue
  // await countsStore.fetchInteractionCounts();
};

// useRoute.query updates twice when routes change
// this is a hack way to only fire this watcher when queries actually change
watch(
  queryParams,
  async (newQueryParams, oldQueryParams) => {
    if (_.isEqual(newQueryParams, oldQueryParams)) {
      return;
    }

    const hasNoQuery = !newQueryParams || Object.keys(newQueryParams).length === 0;
    if (hasNoQuery && currentCategory.value) {
      return;
    }

    await getThreads(newQueryParams);
  },
  {
    immediate: true,
  }
);
</script>

<template>
  <b-col sm="3" class="vh-100 inbox sidebar overflow-auto">
    <InboxLeftMenu />
  </b-col>
  <b-col class="p-0 d-flex flex-column position-relative overflow-x-scroll">
    <router-view />
  </b-col>
</template>

<style lang="scss">
  .inbox {
    background-color: $neutral-500;
    padding: 3rem 1.5rem;
  }

  .sidebar {
    max-width: 15rem;
  }
</style>
